<template>
  <div class="grid-x grid-padding-x align-middle contentContainer">
    <div class="cell small-8 medium-9 large-9 contentPosition">
      <img class="quoteImg" src="@/assets/img/icons/quote-large-trans.png" alt="recruitment quote" />
      <h2>We’re thrilled. We’ve more than doubled the number of Black graduates we recruit.</h2>
      <span class="name">Jacob Rosenzweig</span>
      <span class="position hide-for-medium">xJacob Rosenzweig, Partner and Managing Director at BCG</span>
      <span class="position show-for-medium">Partner and Managing Director</span>
      <img class="logoImg show-for-large" src="@/assets/img/logos/home-page-logos/BCG-white.png" alt="Boston Consulting Group - Graduate Recruitment" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'RareHomeProductsHeaderContents',
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .contentContainer {
    height: 100%;
  }

  h2 {
    color: #ffffff;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }


  .name {
    color: $green-highlight ;
    display: block;
    letter-spacing: 2px;
    text-transform: uppercase;
  }

  .position {
    color: #ffffff;
    display: block;
    letter-spacing: 2px;
    text-transform: uppercase;
  }


  @media only screen and (max-width: 640px)  {
    .contentPosition {
      padding-left: 6%;
    }

    .name {
      font-size: 12px;
    }

    .position {
      font-size: 10px;
    }

    .quoteImg {
      margin-bottom: 5px;
      max-height: 24px;
    }

    h2 {
      font-size: 21px;
      line-height: 1.33;
    }
  }

  @media only screen and (min-width: 641px) and (max-width: 1150px)  {
    .contentPosition {
      padding: 0 0 0 5%;
    }

    .name {
      font-size: 18px;
    }

    .position {
      font-size: 12px;
    }

    .quoteImg {
      margin-bottom: 10px;
      max-height: 36px;
    }

    .logoImg {
      display: none;
    }


    h2 {
      font-size: 48px;
      line-height: 1.25;
    }
  }

  @media only screen and (min-width: 1050px)  {
    .contentPosition {
      padding: 0 0 0 12%;
    }

    .name {
      font-size: 24px;
    }

    .position {
      font-size: 18px;
    }

    .quoteImg {
      margin-bottom: 10px;
      max-height: 48px;
    }

    .logoImg {
      margin-top: 20px;
      max-height: 74px;
    }

    h2 {
      font-size: 56px;
      line-height: 1.25;
    }
  }


</style>



// WEBPACK FOOTER //
// src/pages/homeProducts/homeProductsAttractionAndDevelopment/components/RareHomeProductsHeaderContents.vue